import React from 'react';
import { LIFECYCLE, CONTRACT_LABELS, type LifecycleStatus, type ContractType } from '../../lib/appointmentLifecycle';
import StatusBadge from '../../components/refonte/StatusBadge';
import ContractBadge from '../../components/refonte/ContractBadge';
import StatTile from '../../components/refonte/StatTile';
import MiniBars from '../../components/refonte/MiniBars';

const allStatuses = Object.keys(LIFECYCLE) as LifecycleStatus[];
const allContracts = Object.keys(CONTRACT_LABELS) as ContractType[];

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <section className="bg-panel border border-line rounded-card p-5 mb-4">
    <h2 className="font-mono text-[10.5px] uppercase tracking-widest text-dim mb-4">{title}</h2>
    {children}
  </section>
);

// Kit de composants — QA design. Tous les composants refonte dans tous leurs états.
// Hors menus (route interne /app/_kit).
const KitPage: React.FC = () => (
  <div>
    <h1 className="text-[21px] font-bold tracking-tight">Kit de composants</h1>
    <p className="text-dim text-[13px] mb-5">QA design · tous les états · route interne /app/_kit</p>

    <Section title="StatusBadge · tous les statuts + hors cycle">
      <div className="flex flex-wrap gap-2 items-center">
        <StatusBadge status={null} />
        {allStatuses.map(s => <StatusBadge key={s} status={s} />)}
      </div>
    </Section>

    <Section title="ContractBadge · 3 types + inconnu">
      <div className="flex flex-wrap gap-2 items-center">
        {allContracts.map(c => <ContractBadge key={c} contractType={c} />)}
        <ContractBadge contractType={null} />
      </div>
    </Section>

    <Section title="StatTile · avec / sans tendance">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        <StatTile value={42} label="RDV à facturer" hint="Variable encaissable" />
        <StatTile value={18} label="Effectués" trend={{ direction: 'up', label: '+12 %' }} />
        <StatTile value={3} label="No-show" trend={{ direction: 'down', label: '-2' }} />
        <StatTile value={<span className="text-faint">— €</span>} label="CA" trend={{ direction: 'flat', label: 'stable' }} />
      </div>
    </Section>

    <Section title="MiniBars · valeurs, plat, vide">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 items-end">
        <div>
          <div className="font-mono text-[9px] uppercase tracking-widest text-faint mb-2">Série</div>
          <MiniBars data={[3, 7, 2, 9, 5, 8, 4]} />
        </div>
        <div>
          <div className="font-mono text-[9px] uppercase tracking-widest text-faint mb-2">Plat</div>
          <MiniBars data={[4, 4, 4, 4]} />
        </div>
        <div>
          <div className="font-mono text-[9px] uppercase tracking-widest text-faint mb-2">Vide</div>
          <MiniBars data={[]} />
        </div>
      </div>
    </Section>
  </div>
);

export default KitPage;
